var _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrivateBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8068 10.2171C12.2794 10.8719 12.0931 11.825 12.0931 13.0233V14.5116C12.0931 14.8199 11.8432 15.0698 11.5349 15.0698C11.2267 15.0698 10.9768 14.8199 10.9768 14.5116V13.0233C10.9768 11.7582 11.1626 10.4788 11.9375 9.51685C12.7334 8.52883 14.0441 8 16.0001 8C17.9561 8 19.2668 8.52883 20.0626 9.51685C20.8375 10.4788 21.0233 11.7582 21.0233 13.0233V14.5116C21.0233 14.8199 20.7734 15.0698 20.4652 15.0698C20.1569 15.0698 19.907 14.8199 19.907 14.5116V13.0233C19.907 11.825 19.7208 10.8719 19.1933 10.2171C18.6869 9.58838 17.765 9.11628 16.0001 9.11628C14.2351 9.11628 13.3133 9.58838 12.8068 10.2171Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 17.6744C15.2806 17.6744 14.6976 18.2575 14.6976 18.9767C14.6976 19.696 15.2806 20.279 15.9999 20.279C16.7192 20.279 17.3022 19.696 17.3022 18.9767C17.3022 18.2575 16.7192 17.6744 15.9999 17.6744ZM13.5813 18.9767C13.5813 17.641 14.6641 16.5581 15.9999 16.5581C17.3357 16.5581 18.4185 17.641 18.4185 18.9767C18.4185 20.3125 17.3357 21.3953 15.9999 21.3953C14.6641 21.3953 13.5813 20.3125 13.5813 18.9767Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69699 15.6504C9.31634 16.031 9.11628 16.7401 9.11628 18.2324V19.7208C9.11628 21.2132 9.31634 21.9222 9.69699 22.3029C10.0776 22.6835 10.7867 22.8836 12.2791 22.8836H19.7209C21.2133 22.8836 21.9224 22.6835 22.303 22.3029C22.6837 21.9222 22.8837 21.2132 22.8837 19.7208V18.2324C22.8837 16.7401 22.6837 16.031 22.303 15.6504C21.9224 15.2697 21.2133 15.0696 19.7209 15.0696H12.2791C10.7867 15.0696 10.0776 15.2697 9.69699 15.6504ZM8.90766 14.861C9.64329 14.1254 10.7947 13.9534 12.2791 13.9534H19.7209C21.2053 13.9534 22.3567 14.1254 23.0923 14.861C23.828 15.5967 24 16.7481 24 18.2324V19.7208C24 21.2052 23.828 22.3566 23.0923 23.0922C22.3567 23.8279 21.2053 23.9999 19.7209 23.9999H12.2791C10.7947 23.9999 9.64329 23.8279 8.90766 23.0922C8.17203 22.3566 8 21.2052 8 19.7208V18.2324C8 16.7481 8.17203 15.5967 8.90766 14.861Z",
    fill: "#2E3A59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#D8DCE0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateBoard);
export default __webpack_public_path__ + "static/media/privateBoard.e8480f8f.svg";
export { ForwardRef as ReactComponent };